<div class="search-section py-3 px-2 pt-2">
    <form class="p-0 border-0">
        <div *ngIf="isLoading" class="input-group search-section-skeleton">
            <div class="search-skeleton skeleton-placeholder"></div>
        </div>
        <ng-container *ngIf="RapidQueryListPermission || !isSignInUser()">
            <div class="input-container" *ngIf="!isLoading" style="position: relative; z-index: 100">
                <input
                    type="text"
                    class="form-control text-box-size shadow-sm"
                    [(ngModel)]="searchText"
                    name="searchText"
                    (focus)="onFocus()"
                    (blur)="onBlur()"
                    placeholder="Select your query"
                    [attr.id]="'gyan-name-textbox'"
                    [attr.data-test]="'gyan-name-textbox'"
                />
                <div [ngClass]="{ 'search-input-dropdown': !isMobile, 'search-input-box-mobile': isMobile }" type="button" (click)="onFocus()"></div>
                <!-- <fa-icon class="arrow-icon" [icon]="faAngleDown"></fa-icon> -->
                <div class="dropdown" *ngIf="showDropdown && filteredSearches.length > 0">
                    <div
                        class="dropdown-item"
                        *ngFor="let search of filteredSearches; let i = index"
                        (mousedown)="onSelect(search.query)"
                        (mouseenter)="highlighted = search.query"
                        (mouseleave)="highlighted = ''"
                        [class.highlight]="highlighted === search.query"
                        [attr.id]="'gyan-name-data-' + i"
                        [attr.data-test]="'gyan-name-data-' + i"
                    >
                        {{ search.query }}
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!RapidQueryListPermission && isSignInUser()">
            <div class="input-group" *ngIf="!isLoading">
                <input
                    type="text"
                    #gyanTitleText
                    class="form-control text-box-size shadow-sm"
                    (paste)="onPaste($event)"
                    (input)="sanitizeInput($event, gyanTitleText)"
                    (keydown.enter)="initiateSearch($event, gyanTitleText)"
                    placeholder="Type your query"
                    [attr.id]="'gyan-name-textbox'"
                    [attr.data-test]="'gyan-name-textbox'"
                />
                <button
                    class="btn btn-outline-secondary search-input-box"
                    type="button"
                    [attr.id]="'submit-gyan'"
                    [attr.data-test]="'submit-gyan'"
                    (click)="initiateSearch($event, gyanTitleText)"
                ></button>
            </div>
        </ng-container>
    </form>
</div>
